import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";

export default function Register() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Compte créé — bienvenue !");
      nav("/catalog");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F3ED] flex">
      <div className="hidden lg:flex lg:w-1/2 relative">
        <img
          src="https://images.pexels.com/photos/7031722/pexels-photo-7031722.jpeg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
        <div className="relative z-10 p-12 self-end text-white">
          <div className="text-xs tracking-[0.25em] uppercase font-semibold mb-4">accès privé</div>
          <h2 className="font-serif text-4xl leading-tight italic">« Rejoignez le cercle. »</h2>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Link to="/" className="font-serif text-2xl text-[#2B3029]">matchappart</Link>
          <h1 className="font-serif text-4xl mt-10 text-[#1A1A1A]">Créer mon compte</h1>
          <p className="mt-3 text-sm text-[#666]">
            Entrez l'email <strong>pré-autorisé</strong> par l'administrateur. Si votre email n'est pas dans la liste, votre inscription sera refusée.
          </p>
          <form onSubmit={submit} className="mt-10 space-y-5">
            <div>
              <label className="text-xs tracking-[0.2em] uppercase font-semibold text-[#666]">Nom complet</label>
              <input
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full mt-2 px-4 py-3 bg-white border border-[#E5E1D8] rounded-md focus:border-[#8C6C50] focus:outline-none focus:ring-2 focus:ring-[#8C6C50]/20"
                data-testid="register-name-input"
              />
            </div>
            <div>
              <label className="text-xs tracking-[0.2em] uppercase font-semibold text-[#666]">Email autorisé</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full mt-2 px-4 py-3 bg-white border border-[#E5E1D8] rounded-md focus:border-[#8C6C50] focus:outline-none focus:ring-2 focus:ring-[#8C6C50]/20"
                data-testid="register-email-input"
              />
            </div>
            <div>
              <label className="text-xs tracking-[0.2em] uppercase font-semibold text-[#666]">Mot de passe</label>
              <input
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full mt-2 px-4 py-3 bg-white border border-[#E5E1D8] rounded-md focus:border-[#8C6C50] focus:outline-none focus:ring-2 focus:ring-[#8C6C50]/20"
                data-testid="register-password-input"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full py-3.5 rounded-full text-sm font-medium disabled:opacity-60"
              data-testid="register-submit-btn"
            >
              {loading ? "Création…" : "Créer mon compte"}
            </button>
          </form>
          <p className="mt-6 text-sm text-[#666]">
            Déjà inscrit ?{" "}
            <Link to="/login" className="text-[#8C6C50] underline underline-offset-4" data-testid="register-to-login">
              Se connecter
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
